<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="70%" :before-close="closeDialog">

    <div>
      <span class="title" style="color: rgb(88, 88, 88);">起止时间:</span>
      <el-date-picker v-model="search_time" type="daterange" range-separator="-" start-placeholder="开始日期"
        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="timeChange" style="width: 300px;">
      </el-date-picker>
      <el-button @click="toSearch" style="margin-left: 10px;">搜索</el-button>
    </div>

    <div style="width: 100%;margin-top: 20px;">
      <div id="orderFromMoneyCharts" style="height: 400px;"></div>
    </div>

  </el-dialog>
</template>

<script>
  var _this;
  import echarts from 'echarts'
  export default {
    props: {
      'isShow': Boolean,
      'data': '',
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.$nextTick(function () {


          _this.getData();

        });


      },

    },
    data() {
      return {

        show: false,

        search_time: '',

        fixed_array: '',

        //端口订单金额
        orderFromMoneyCharts: '',
        orderFromMoneyOption: {
          title: {
            text: '司机业绩信息'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['金额', '单量']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          xAxis: {
            type: 'category',
            data: ['今日', '本周', '本月', '本年', '自定义时间']
          },
          series: [{
              name: '金额',
              type: 'bar',
              data: []
            },
            {
              name: '单量',
              type: 'bar',
              data: []
            }
          ]
        },





      };
    },
    created() {

      _this = this;

    },
    mounted() {



    },
    methods: {
      getData() {

        _this.$post(
          "/statistics/getDriverPerformance", {
            driver_code: _this.data,
            fixed_array: _this.fixed_array
          }
        ).then(res => {

          _this.orderFromMoneyOption.series[0].data = [];

          _this.orderFromMoneyOption.series[1].data = [];

          _this.orderFromMoneyOption.series[0].data.push(res.data.today.total_amount)
          _this.orderFromMoneyOption.series[0].data.push(res.data.week.total_amount)
          _this.orderFromMoneyOption.series[0].data.push(res.data.month.total_amount)
          _this.orderFromMoneyOption.series[0].data.push(res.data.year.total_amount)
          _this.orderFromMoneyOption.series[0].data.push(res.data.customize.total_amount)




          _this.orderFromMoneyOption.series[1].data.push(res.data.today.count)
          _this.orderFromMoneyOption.series[1].data.push(res.data.week.count)
          _this.orderFromMoneyOption.series[1].data.push(res.data.month.count)
          _this.orderFromMoneyOption.series[1].data.push(res.data.year.count)
          _this.orderFromMoneyOption.series[1].data.push(res.data.customize.count)



          _this.echartsInit()

        }).catch((err) => {

        })

      },
      toSearch() {

        _this.getData();

      },

      // 搜索时间选择触发
      timeChange(val) {

        if(val!== null){
        _this.fixed_array = JSON.stringify(['between'].concat(val));

        }else{
           _this.fixed_array = ''
        }

        console.log(_this.search_data);

      },

      closeDialog() {


        _this.orderFromMoneyOption.series[0].data = [];

        _this.orderFromMoneyOption.series[1].data = [];

        _this.fixed_array = '';

        _this.search_time = '';

        _this.show = false;


      },
      echartsInit() {

        this.orderFromMoneyCharts = echarts.init(document.getElementById('orderFromMoneyCharts'))
        this.orderFromMoneyCharts.setOption(_this.orderFromMoneyOption)


      },


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>